/** User Preferences Types */

/** Bootstrap read — issued once per session, never from a list page. */
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const GET_USER_PREFERENCES_SUCCESS = 'GET_USER_PREFERENCES_SUCCESS';

/**
 * Local-only. Updates the slice the restore gate reads, with no request behind it.
 *
 * Split from SAVE_TAB_FILTERS on purpose: the store has to reflect the filter the
 * user just picked *immediately*, or navigating away and back inside the debounce
 * window would restore the previous filter over the current one. The request that
 * follows is debounced; this is not.
 */
export const SET_TAB_FILTERS = 'SET_TAB_FILTERS';

/** Debounced, fire-and-forget write. No loading state, no error state — see the saga. */
export const SAVE_TAB_FILTERS = 'SAVE_TAB_FILTERS';
export const CLEAR_TAB_FILTERS = 'CLEAR_TAB_FILTERS';
/** End */
